import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createProductFaq = async (payload) => {
  return await axiosInstance.post("product/faq", payload, { headers });
};

export const fetchProductFaqsByProductId = async (productId) => {
  return await axiosInstance.get(`products/${productId}/faqs`, { headers });
};

export const deleteProductFaq = async (groupId) => {
  return await axiosInstance.delete(`product/faq/${groupId}`, { headers });
};

export const updateProductFaq = async (payload) => {
  return await axiosInstance.put("product/faq", payload, { headers });
};

export const fetchProductFaqbyId = async (id) => {
  const response = await axiosInstance.get(`product/faq/${id}`, {
    headers,
  });
  return response.data;
};
